export const LANGUAGES = [
  { value: "en", label: "languageoption.english", icon: "circle-flags:gb" },
  { value: "nl", label: "languageoption.nederlands", icon: "circle-flags:nl" },
  { value: "de", label: "languageoption.deutsch", icon: "circle-flags:de" },
  { value: "fr", label: "languageoption.french", icon: "circle-flags:fr" },
] as const;

export const DEFAULT_LANGUAGE: (typeof LANGUAGES)[number]["value"] = "en";

export const LANGUAGE_COOKIE_NAME = "language";
